import CKEditor from "ckeditor4-react";
import React from "react";
import DatePicker from "react-datepicker";
import { config } from "../../../config/config";

class AddBlog extends React.Component {
  constructor(props) {
    super(props);
    this.onEditorChange = this.onEditorChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onFileUploadReq = this.onFileUploadReq.bind(this);
    this.onFileUploadRes = this.onFileUploadRes.bind(this);
    this.state = {
      editblogData: {},
      errors: {},
    };
  }

  handleInputChange(e) {
    const { name, value } = e.target;
    console.log(name, value);
    let fields = this.state.editblogData;
    fields[name] = value;
    if (name === "title") {
      let slug = value.trim();
      slug = slug.toLowerCase();
      slug = slug.split(" ");
      slug = slug.filter((e) => e !== "");
      slug = slug.join("-");
      fields["slug"] = slug;
    }
    this.setState({
      fields,
    });
  }

  handleDateChange(date, name) {
    // console.log(date)
    // console.log(this.state)
    let fields = this.state.editblogData;
    fields[name] = date;
    this.setState({
      fields,
    });
  }

  onEditorChange(e) {
    console.log(e);
    let fields = this.state.editblogData;
    fields["content_html"] = e.editor.getData();
    this.setState({
      fields,
    });
  }

  /**
   * Summary. Function used to send server request to upload image.
   *
   * @param {*} e  ckeditor upload event
   */
  onFileUploadReq(e) {
    // console.log(e);
    let xhr = e.data.fileLoader.xhr;
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Authorization", "Bearer " + this.props.token);
    xhr.send(
      JSON.stringify({ base64ImageUrl: e.data.fileLoader.data.split(",")[1] })
    );
    e.stop();
    e.cancel();
  }

  /**
   * Summary. Function used to get response of upload editor image from server.
   * @param {*} e upload response event
   */
  onFileUploadRes(e) {
    e.stop();
    // console.log(e.data);
    let data = e.data;
    let xhr = data.fileLoader.xhr;
    // console.log(xhr)
    let response = xhr.responseText.split("|");
    // console.log(response)
    if (response[1]) {
      // An error occurred during upload.
      data.message = response[1];
      e.cancel();
    } else {
      let parse_response = JSON.parse(response[0].toString());
      data.url = parse_response["responceObject"]["records"]["url"];
    }
  }

  onSubmit(e) {
    e.preventDefault();
    console.log(this.state.editblogData);
  }

  onCancel(e) {
    e.preventDefault();
  }

  render() {
    console.log(this.state.editblogData);
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="filters">
              <div className="brd-1 pt-1">
                <div className="row pt-1">
                  <div className="col-lg-6">
                    <div className="date">
                      <p className="datetext">Start Date</p>
                      <DatePicker
                        className="form-control"
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeCaption="time"
                        dateFormat="MMMM d, yyyy h:mm aa"
                        minDate={new Date()}
                        selected={this.state.editblogData.publish_start}
                        onChange={(date) =>
                          this.handleDateChange(date, "publish_start")
                        }
                      />
                      <div className="errorMsg">
                        {this.state.errors["publish_start"]}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="date">
                      <p className="datetext">End Date</p>
                      <DatePicker
                        className="form-control"
                        showTimeSelect
                        timeFormat="HH:mm"
                        timeCaption="time"
                        dateFormat="MMMM d, yyyy h:mm aa"
                        minDate={this.state.editblogData.publish_start}
                        selected={this.state.editblogData.publish_end}
                        onChange={(date) =>
                          this.handleDateChange(date, "publish_end")
                        }
                      />
                      <div className="errorMsg">
                        {this.state.errors["publish_end"]}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-xl-6">
            <div className="d-block align-items-center mt-2">
              <label className="title-label">Title</label>
              <input
                type="text"
                name="title"
                className="form-control"
                placeholder="Enter Title"
                onChange={this.handleInputChange}
                value={this.state.editblogData.title || ""}
              />
              <div className="errorMsg">{this.state.errors["title"]}</div>
            </div>
          </div>
          <div className="col-lg-6 col-xl-6">
            <div className="d-block align-items-center mt-2">
              <label className="title-label">Slug</label>
              <input
                type="text"
                readOnly
                name="slug"
                className="form-control"
                placeholder="Enter Slug"
                value={this.state.editblogData.slug || ""}
              />
              <div className="errorMsg">{this.state.errors["slug"]}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 pt-1">
            <div className="d-block align-items-center mt-2">
              <label className="title-label">Content</label>
              <CKEditor
                onBeforeLoad={(CKEDITOR) => (
                  (CKEDITOR.disableAutoInline = true),
                  CKEDITOR.addCss(
                    'body.cke_editable { font-family: "Open Sans";font-size: 16px;line-height: 1.6;color: #586667;background-color: #ffffff;}p {color: #000;font-family: "Open Sans";font-size: 16px;}a {color: #C41425;text-decoration: none;}h1, h2, h3, h4, h5, h6, li  {color: #000}'
                  ),
                  CKEDITOR.plugins.add("iFrame", {
                    icons: "abbr",
                  })
                )}
                config={{
                  versionCheck: false,
                  stylesSet: [
                    // Block-level styles.
                    {
                      name: "Content title",
                      element: "h1",
                      styles: {
                        color: "#C41425",
                        "font-family": "Open Sans Semibold",
                        "line-height": "135%",
                      },
                    },
                    {
                      name: "Content Info",
                      element: "p",
                      styles: {
                        color: "#586667",
                        padding: "0px !important",
                        "font-family": "Open Sans Light",
                        "font-size": "14px",
                      },
                    },
                    // Inline styles.
                    {
                      name: "Text Gray",
                      element: "p",
                      styles: {
                        color: "#AAA !important",
                        "font-family": "Open Sans Light",
                        "font-size": "16px",
                      },
                    },
                    {
                      name: "Anchor Red",
                      element: "a",
                      styles: {
                        color: "#C41425 !important",
                        "text-decoration": "none",
                      },
                    },
                  ],
                  format_tags: "p;h1;h2;h3;h4;h5;h6;pre;address;div",
                  extraPlugins: "embed,autoembed,iframe",
                  // filebrowserBrowseUrl: '/browser/browse.php',
                  filebrowserUploadUrl:
                    config.api_url + config.url.upload_editor_image,
                  embed_provider:
                    "//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}",
                }}
                onFileUploadRequest={this.onFileUploadReq}
                onFileUploadResponse={this.onFileUploadRes}
                onChange={this.onEditorChange}
                data={this.state.editblogData.content_html || ""}
              />
              <div className="errorMsg">
                {this.state.errors["content_html"]}
              </div>
            </div>
          </div>
        </div>
        <div>
          <button
            className="form-btn ml-0"
            type="button"
            onClick={this.onSubmit.bind(this)}
          >
            Submit
          </button>
          <button
            className="form-btn"
            type="button"
            onClick={this.onCancel.bind(this)}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }
}
export default AddBlog;
